import { render, staticRenderFns } from "./panelTypeForm.vue?vue&type=template&id=2cf6a36a&%23default=true&"
import script from "./panelTypeForm.vue?vue&type=script&lang=js&"
export * from "./panelTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports